const remoteUrl = process.env.REACT_APP_REMOTE_URL;

export const remotesConfigs = [
    {
        name: 'preact',
        urls: [
            'https://cdn.jsdelivr.net/npm/preact@10.10.0/dist/preact.min.js',
        ],
        attributes: {},
        globalName: 'preact',
        type: 'script',
    },
    {
        name: 'preactHooks',
        urls: [
            'https://cdn.jsdelivr.net/npm/preact@10.10.0/hooks/dist/hooks.umd.js',
        ],
        attributes: {},
        globalName: 'preactHooks',
        type: 'script',
    },
    {
        name: 'preactSignals',
        urls: [
            'https://cdn.jsdelivr.net/npm/@preact/signals@2.2.0/dist/signals.min.js',
        ],
        attributes: {},
        globalName: 'preactSignals',
        type: 'script',
    },
    {
        name: 'preactSignalsCore',
        urls: [
            'https://cdn.jsdelivr.net/npm/@preact/signals-core@1.9.0/dist/signals-core.min.js',
        ],
        attributes: {},
        globalName: 'preactSignalsCore',
        type: 'script',
    },
    {
        name: 'preactSignalsReact',
        urls: [
            'https://cdn.jsdelivr.net/npm/@preact/signals-react@1.1.0/dist/signals-react.umd.js',
        ],
        attributes: {},
        globalName: 'preactSignalsReact',
        type: 'script',
    },
    {
        name: 'state-permissions',
        urls: [`${remoteUrl}/shared-state/permissions/permission-store.umd.js`],
        attributes: {},
        globalName: 'LSQStatePermissions',
        type: 'script',
    },
    {
        name: 'bot-conversation',
        urls: [`${remoteUrl}/bot-conversation/federation.umd.js`],
        attributes: {},
        globalName: 'BotConversation',
        type: 'script',
    },
    {
        name: 'bot-conversation-css',
        urls: [`${remoteUrl}/bot-conversation/bot-conversation.css`],
        attributes: {},
        identifier: 'bot-conversation-css',
        type: 'stylesheet',
    },
];
